import React, { useState, useEffect, useContext } from 'react';
import { SimpleModal } from 'react-onei';
import { events } from '../../conf/tags_ga.conf';
import UserContext from '../../context/UserContext';
import TagService from '../../services/TagService';

function checkRangeDates(today = new Date()) {
    const { feedbackStartDate, feedbackEndDate } = window.reactAppEnv.features;
    const date = Date.parse(today);
    const startDate = Date.parse(feedbackStartDate);
    const endDate = Date.parse(feedbackEndDate);
    if (isNaN(date) || isNaN(startDate) || isNaN(endDate)) {
        return false
    }
    return ((startDate <= date) && (date <= endDate));
}

function Popin() {
    const { webViewMode, wording } = useContext(UserContext);
    const [isActive, setIsActive] = useState(!webViewMode && window.reactAppEnv.features.feedback && checkRangeDates());
    const { WLOST_620, WLOST_621, WLOST_622 } = wording;

    const handleClose = () => {
        TagService.sendEvent(events.closeDialog);
        setIsActive(false);
    }

    const handleClick = () => {
        TagService.sendEvent(events.openFeedback);
        window.open(window.reactAppEnv.href.feedbackForm, '_blank');
        setIsActive(false);
    }

    useEffect(() => {
        if (isActive) {
            TagService.sendPageView({ 'name': 'ouverture_popin_harris' }, true);
        }
    }, [isActive]);

    if (isActive) {
        return (
            <SimpleModal
                id="popin"
                displayed={isActive}
                title={WLOST_620}
                text={WLOST_621}
                button={WLOST_622}
                onButtonClick={handleClick}
                onClose={handleClose}
                closeOnOverlayClick={false}
            />
        )
    }
    return null;
};

export default Popin;